import React, { Component } from "react";
import { Glyphicon, Col, Row, Grid, Modal } from "react-bootstrap";
import classnames from "classnames";
import styles from "./AdminCompany.scss";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import moment from "moment";
import Button from "../../../../components/common/button/Button";
import { Link } from "react-router-dom";
import AdminCompanyNav from "./AdminCompanyNav";

class AdminCompany extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show || false,
      selectedManager: null
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(manager) {
    this.setState({ show: true, selectedManager: manager });
  }

  handleClose() {
    this.setState({ show: false, selectedManager: null });
  }

  chargeClient(id) {
    window.open(`https://dashboard.stripe.com/test/customers/${id}`, "_blank");
  }

  renderPaymentTerm(term, other) {
    if (term === "Other") {
      return `Net-${other}`;
    }

    return term;
  }

  render() {
    const { companyData } = this.props;

    if (!companyData) return null;

    return (
      <section className={styles.adminCompanyContainer}>
        <ScrollToTopOnMount />
        <section className={styles.textFont}>
          <AdminCompanyNav
            id={companyData.id}
            projectsCount={companyData.projects && companyData.projects.length}
          />
          <Grid className={styles.maxWidth}>
            <Row>
              <Col>
                <div className={styles.headerContainer}>
                  <h1>{companyData.name}</h1>
                </div>
                <p className={styles.subtitle}>
                  Active since{" "}
                  {moment(companyData.created_at).format("MMMM DD, YYYY")}
                </p>
                &nbsp;
              </Col>
            </Row>
            <Row>
              <div className={styles.dividerDouble} />
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Summary</h2>
              <Link to={`/admin/company/${companyData.id}/edit`}>
                <Glyphicon glyph="pencil" />
              </Link>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <p>{companyData.summary}</p>
              </div>
            </Row>

            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Company Vitals</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <div>
                  <Row className={styles.box}>
                    <Col xs={12} sm={4} md={3}>
                      <p>
                        <span className={styles.companyVitalsTitle}>
                          Industry
                        </span>
                      </p>
                    </Col>
                    <Col xs={12} sm={8} md={3}>
                      <p>
                        <span className={styles.companyVitalsDesc}>
                          {companyData.industry && companyData.industry.value}
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <div className={styles.divider} />
                  <Row className={styles.box}>
                    <Col xs={12} sm={4} md={3}>
                      <p>
                        <span className={styles.companyVitalsTitle}>
                          Company Size
                        </span>
                      </p>
                    </Col>
                    <Col xs={12} sm={8} md={9}>
                      <p>
                        <span className={styles.companyVitalsDesc}>
                          {companyData.company_size &&
                            companyData.company_size.value}
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <div className={styles.divider} />
                  <Row className={styles.box}>
                    <Col xs={12} sm={4} md={3}>
                      <p>
                        <span className={styles.companyVitalsTitle}>
                          Location
                        </span>
                      </p>
                    </Col>
                    <Col xs={12} sm={8} md={9}>
                      <p>
                        <span className={styles.companyVitalsDesc}>
                          {companyData.location}
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <div className={styles.divider} />
                  <Row className={styles.box}>
                    <Col xs={12} sm={4} md={3}>
                      <p>
                        <span className={styles.companyVitalsTitle}>
                          Website or LinkedIn
                        </span>
                      </p>
                    </Col>
                    <Col xs={12} sm={8} md={9}>
                      <p>
                        {companyData.url && (
                          <a
                            href={
                              companyData.url.indexOf("http://") < 0 &&
                              companyData.url.indexOf("https://") < 0
                                ? "//" + companyData.url
                                : companyData.url
                            }
                            target="_blank"
                            className={styles.companyVitalsLink}
                          >
                            {companyData.url}
                          </a>
                        )}
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </Row>

            {companyData.managers && companyData.managers.length > 0 && (
              <div>
                <div>
                  <div className={classnames(styles.editLink, "row")}>
                    <h2 className={styles.header}>Hiring Managers</h2>
                  </div>
                  <Row>
                    <div className={styles.whiteBackground}>
                      <div>
                        {companyData.managers &&
                          companyData.managers.map((manager, index) => (
                            <div key={index}>
                              {index > 0 && <div className={styles.divider} />}
                              <Row className={styles.box}>
                                <Col xs={12} sm={3}>
                                  <p>
                                    <span className={styles.companyVitalsTitle}>
                                      {manager.first_name}
                                      &nbsp;
                                      {manager.last_name}
                                    </span>
                                  </p>
                                </Col>
                                <Col xs={12} sm={3}>
                                  <p>
                                    <a
                                      href={`mailto:${manager.email}`}
                                      className={styles.companyVitalsLink}
                                    >
                                      {manager.email}
                                    </a>
                                  </p>
                                </Col>
                                {manager.profile.referral_value != "Other" &&
                                manager.profile.referral_value != null ? (
                                  <Col xs={12} sm={2}>
                                    <p>
                                      <span
                                        className={styles.companyVitalsDesc}
                                      >
                                        Referrer:
                                        <br />
                                        {manager.profile.referral_value}
                                      </span>
                                    </p>
                                  </Col>
                                ) : (
                                  <Col xs={12} sm={2}>
                                    <p>
                                      <span
                                        className={styles.companyVitalsDesc}
                                      >
                                        No Referrer
                                      </span>
                                    </p>
                                  </Col>
                                )}

                                {manager.profile.referral_code ? (
                                  <Col xs={12} sm={3}>
                                    <p>
                                      <span
                                        className={styles.companyVitalsDesc}
                                      >
                                        Referral Code:
                                        <br />
                                        {manager.profile.referral_code}
                                      </span>
                                    </p>
                                  </Col>
                                ) : (
                                  <Col xs={12} sm={3}>
                                    <p>
                                      <span
                                        className={styles.companyVitalsDesc}
                                      >
                                        No Referral Code
                                      </span>
                                    </p>
                                  </Col>
                                )}

                                <Col xs={12} sm={1} className={styles.actions}>
                                  <Link
                                    to={`/admin/company/manager/${manager.id}`}
                                  >
                                    <Glyphicon glyph="pencil" />
                                  </Link>
                                  <button
                                    className={styles.button}
                                    onClick={() => this.handleOpen(manager)}
                                  >
                                    <Glyphicon glyph="remove" />
                                  </button>
                                </Col>
                              </Row>
                            </div>
                          ))}
                      </div>
                    </div>
                  </Row>
                </div>

                <div className={classnames(styles.editLink, "row")}>
                  <h2 className={styles.header}>Payment Information</h2>
                  <Link to={`/admin/company/${companyData.id}/edit/billing`}>
                    <Glyphicon glyph="pencil" />
                  </Link>
                </div>
                <Row>
                  <div className={styles.whiteBackground}>
                    <div>
                      <Row className={styles.box}>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsTitle}>
                              Billing Contact
                            </span>
                          </p>
                        </Col>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsDesc}>
                              {_.get(companyData, "payment.first_name")}{" "}
                              {_.get(companyData, "payment.last_name")}
                              <br />
                              {_.get(companyData, "payment.email")}
                            </span>
                          </p>
                        </Col>
                      </Row>
                      {/* <div className={styles.divider} />
                      <Row className={styles.box}>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsTitle}>
                              Payment Terms
                            </span>
                          </p>
                        </Col>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsDesc}>
                              {this.renderPaymentTerm(
                                _.get(
                                  companyData,
                                  "payment.payment_term.value"
                                ),
                                _.get(companyData, "payment.payment_term_other")
                              )}
                            </span>
                          </p>
                        </Col>
                      </Row> */}
                      <div className={styles.divider} />
                      <Row className={styles.box}>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsTitle}>
                              Preferred Payment Method
                            </span>
                          </p>
                        </Col>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsDesc}>
                              {_.get(
                                companyData,
                                "payment.payment_method.value"
                              )}
                            </span>
                          </p>
                        </Col>
                      </Row>
                      <div className={styles.divider} />
                      <Row className={styles.box}>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsTitle}>
                              Billing Notes
                            </span>
                          </p>
                        </Col>
                        <Col xs={12} sm={6}>
                          <p>
                            <span className={styles.companyVitalsDesc}>
                              {_.get(companyData, "payment.billing_notes")}
                            </span>
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Row>

                <div>
                  <div className={classnames(styles.editLink, "row")}>
                    <h2 className={styles.header}>Credit Card Information</h2>
                  </div>
                  <Row>
                    <div className={styles.whiteBackground}>
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Cardholder</th>
                            <th scope="col">Credit Card</th>
                            <th scope="col">Exp. Date</th>
                            <th scope="col">Stripe Token</th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>
                          {companyData.managers &&
                            companyData.managers.map(manager => {
                              return (
                                manager.stripe &&
                                manager.stripe.sources &&
                                manager.stripe.sources.data &&
                                manager.stripe.sources.data.map(card => {
                                  return (
                                    <tr>
                                      <th
                                        scope="row"
                                        className={styles.vertical}
                                      >
                                        {card.name}
                                      </th>
                                      <td className={styles.vertical}>
                                        **** {card.last4}
                                      </td>
                                      <td className={styles.vertical}>
                                        {card.exp_month} / {card.exp_year}
                                      </td>
                                      <td className={styles.vertical}>
                                        {card.customer}
                                      </td>
                                      <td className={styles.vertical}>
                                        <Button
                                          isPrimary
                                          isVerySmall
                                          noMarginBottom
                                          type="submit"
                                          label="Charge Client"
                                          onClick={() =>
                                            this.chargeClient(card.customer)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  );
                                })
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </Row>
                </div>
              </div>
            )}
          </Grid>
        </section>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName={styles.modalContainer}
        >
          <Modal.Body className={styles.modalBody}>
            <div className={styles.title}>
              Are you sure you want to remove&nbsp;
              {this.state.selectedManager
                ? this.state.selectedManager.first_name
                : "selected manager"}
              ?
            </div>
            <div className={styles.dividerDouble} />

            <div className={styles.CTAContainer}>
              <Button
                isPrimary
                isSmall
                label="Yes"
                onClick={() => {
                  this.props.removeUser(this.state.selectedManager.id);
                  this.handleClose();
                }}
              />

              <Button
                isSecondary
                isSmall
                label="No"
                onClick={() => {
                  this.handleClose();
                }}
              />
            </div>
          </Modal.Body>
        </Modal>
      </section>
    );
  }
}

export default AdminCompany;



// WEBPACK FOOTER //
// ./src/routes/admin/company/components/AdminCompany.js